// extracted by mini-css-extract-plugin
export default {"fontSizeVariable":"--font-size","badge":"BetaBadge_badge__jxxks"};